// extracted by mini-css-extract-plugin
module.exports = {"title":"Home_title__cCUvM","rows":"Home_rows__3Qud7","loading":"Home_loading__1xmlX","error":"Home_error__2K9Ry"};